module.exports = __webpack_public_path__ + "img/4.beb1f1d5.png";